<template>
    <div class="saas-feature section-space--ptb_90 bg-gray">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center section-space--mb_60">
                        <h2 class="font-weight--light mb-15 wow move-up">{{$t('dahayuksekbuyumeicingelistirildi')}}</h2>
                        <span class="section-text wow move-up">{{$t('isinizebuyumeicineniyiyardimisunun')}}</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
                    <div class="service-grid">
                        <div class="ht-service-box--one style-03">
                            <router-link :to="'branding'">
                                <div class="image__media">
                                    <img :src="item.icon" class="img-fluid" alt="aeroland-app-showcase-box-icon-image-01">
                                </div>
                                <div class="content">
                                    <h6 class="heading">{{ $t(item.heading) }}</h6>
                                    <div class="service_text">{{ $t(item.text) }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SassFeature',
        data (){
            return {
                items: [
                    {
                        icon: require('../assets/img/icons/aeroland-box-image-01.png'), 
                        heading: 'guvenilirhizmetler', 
                        text: '7/24 Destek, Konusunda Uzman Teknik Personeller, Periyodik Eğitimler, Müşteri yerinde destek imkanı'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-box-image-02.png'), 
                        heading: 'kapsamlidokumanlar', 
                        text: 'Geliştirilen her uygulamanın talep aşamasından itibaren tüm süreçleri kayıt altına alınmaktadır.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-box-image-03.png'), 
                        heading: 'musteridestegi', 
                        text: 'Müşteri temsilcileri aracılığı ile Uzaktan veya Müşteri Yerinde destek verilmektedir.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-box-image-04.png'), 
                        heading: 'garantilibuyume',  
                        text: 'Daha iyi yazılım genel satışları & net kârı artırır'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-box-image-05.png'), 
                        heading: 'Entegrasyon', 
                        text: 'Web Sitenizle Entegrasyon, Yazarkasa,Terazi Entegrsayonu , e-ticaret Entegrasyonları, Diğer Programlarla veri Alışverişi'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-box-image-06.png'), 
                        heading: 'musteriyonetimi', 
                        text: 'Müşteriye tanımlı Müşteri temsilciler aracılığı ile belirli periyodlarda müşteri ziyareti ve yeniliklerin anlatılması ve uygulaması yapılmaktadır.'
                    },
                ]
            }
        }
    }
</script>
